import React, { useState } from "react";
import { Table, TableHead, TableBody, TableRow, TableCell, Paper, TableContainer } from "@mui/material";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { Progress } from "../../../components/styles/styles";
import Loading from "../../../components/loading";
import "./style.css";

const itemsPerPage = 15; // Quantidade de itens por página

function TabelaSimples(props) {
	const [page, setPage] = useState(1);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const startIndex = (page - 1) * itemsPerPage;
	const endIndex = startIndex + itemsPerPage;
	const slicedData = props.list.slice(startIndex, endIndex);

	// Obtém as chaves das colunas com base no primeiro item da lista ou nas props
	const columnKeys = props.list && props.list.length > 0 ? Object.keys(slicedData[0]) : props.columns || [];

	return (
		<>
			{props.loading ? (
				<Loading />
			) : (
				// <Paper>
				<TableContainer component={Paper}>
					<Table>
						<TableHead className="color-table">
							<TableRow>
								{columnKeys.map((key) => (
									<TableCell key={key}>
										<span className="text-color-table">{key}</span>
									</TableCell>
								))}
							</TableRow>
						</TableHead>
						<TableBody>
							{!props.list || props.list.length === 0 ? (
								<TableRow>
									<TableCell
										colSpan={columnKeys.length || 1}
										style={{
											padding: "16px 20px",
											color: "#6c757d",
											fontStyle: "italic",
											textAlign: "left",
											height: "60px",
										}}
									>
										Nenhum registro encontrado.
									</TableCell>
								</TableRow>
							) : (
								slicedData.map((item, index) => (
									<TableRow key={index} className="zebra-row">
										{columnKeys.map((key) => (
											<TableCell key={key}>{item[key]}</TableCell>
										))}
									</TableRow>
								))
							)}
						</TableBody>
					</Table>
					<Stack
						sx={{
							justifyContent: "center",
							alignItems: "center",
							mt: 2,
						}}
					>
						<Pagination
							count={Math.ceil(props.list.length / itemsPerPage)}
							page={page}
							onChange={handleChangePage}
						/>
					</Stack>
				</TableContainer>
			)}
		</>
	);
}

export default TabelaSimples;
